import { shadeColor, getReadableTextColor } from './helpers.js';
import { createThemeController } from './theme.js';
import staticCSS from './styles.css';
import blocksCSS from './blocks/blocks.css';

// Apply the colour-derived CSS custom properties on the widget root. Split out
// of injectStyles so it can be re-run on a live config update (dashboard
// preview) without re-injecting the stylesheet.
export function applyConfigVars(el, config) {
  el.style.setProperty('--chatyx-primary', config.primaryColor);
  el.style.setProperty('--chatyx-primary-hover', shadeColor(config.primaryColor, -17));
  el.style.setProperty('--chatyx-primary-contrast', getReadableTextColor(config.primaryColor));
  el.style.setProperty('--chatyx-secondary', config.secondaryColor);
  el.style.setProperty('--chatyx-border-color', config.inputBorderColor);
  el.style.setProperty('--chatyx-send-button', config.sendButtonColor);
  el.style.setProperty('--chatyx-send-button-hover', shadeColor(config.sendButtonColor, -17));
  el.style.setProperty('--chatyx-send-button-contrast', getReadableTextColor(config.sendButtonColor));
  el.style.setProperty('--chatyx-bubble-bg', config.bubbleBackground);
  el.style.setProperty('--chatyx-bubble-contrast', getReadableTextColor(config.bubbleBackground));
}

export function injectStyles(el, config) {
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap';
  document.head.appendChild(fontLink);

  const style = document.createElement('style');
  style.textContent = staticCSS + '\n' + blocksCSS;
  el.appendChild(style);

  applyConfigVars(el, config);

  return createThemeController(el, config.theme);
}
